import { render, staticRenderFns } from "./SwitchWithLabel.vue?vue&type=template&id=a6f2dc26&"
import script from "./SwitchWithLabel.vue?vue&type=script&lang=js&"
export * from "./SwitchWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports